import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import customFetch from '../utils/fetch';
export const useUserEmail = () => {
  const {
    data: userEmail,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['userEmail'],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/whoami`, {});
      const details = (await response.json() as {
        email: string;
      });
      return details.email;
    }
  });
  return {
    userEmail,
    isLoading,
    isError,
    error
  };
};